import "./style"
import BodyPortal from "components/body-portal"

const ComponentsLayoutOverlay = (props) => {
  const s = useShape(props)

  const onCloseOverlayButtonClicked = useCallback((e) => {
    e.preventDefault()
    s.p.onRequestClose()
  }, [])

  const onWindowKeyUp = useCallback((e) => {
    const {keyCode} = digs(e, "keyCode")

    if (keyCode == 27) { // Escape key
      e.preventDefault()
      s.p.onRequestClose()
    }
  }, [])

  const {children, className, onRequestClose, ...restProps} = props

  return (
    <BodyPortal>
      {onRequestClose &&
        <EventListener event="keyup" onCalled={onWindowKeyUp} target={window} />
      }
      <div className={classNames("components--layout--overlay", className)} {...restProps}>
        {onRequestClose &&
          <a className="close-overlay-button" href="#" onClick={onCloseOverlayButtonClicked}>
            <i className="fa fa-remove" />
          </a>
        }
        <div className="overlay-container">
          {children}
        </div>
      </div>
    </BodyPortal>
  )
}

ComponentsLayoutOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  onRequestClose: PropTypes.func
}

export default memo(ComponentsLayoutOverlay)
